var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-card',{attrs:{"headStyle":_vm.headStyle}},[_c('div',{staticClass:"mt-2"},[_c('Filters')],1),_c('div',{staticClass:"mt-2"},[_c('ProjectTable',{attrs:{"propData":{
          title: 'Project List',
          columns: _vm.columns,
          tableId: 'restoreProjectTable',
          isActive: false,
          url: _vm.url
        }}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }